export default __webpack_public_path__ + "static/media/R2.4ffd51dc.png";